import React from 'react';
import { Card, CardActionArea, Box, Typography } from '@mui/material';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import AirIcon from '@mui/icons-material/Air';
import BlindsIcon from '@mui/icons-material/Blinds';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import LockIcon from '@mui/icons-material/Lock';
import BoltIcon from '@mui/icons-material/Bolt';
import DevicesOtherIcon from '@mui/icons-material/DevicesOther';
import { deviceTypeKey, deviceLabel } from '../../../core/devices/deviceMeta';
import DeviceStatusDot from './DeviceStatusDot';

function iconFor(deviceId) {
  switch (deviceTypeKey(deviceId)) {
    case 'fan': return <AirIcon fontSize="large" />;
    case 'curtain': return <BlindsIcon fontSize="large" />;
    case 'rgb':
    case 'wwh':
    case 'wwrgb': return <LightbulbIcon fontSize="large" />;
    case 'door': return <LockIcon fontSize="large" />;
    case 'singlePhase':
    case 'threePhase': return <BoltIcon fontSize="large" />;
    case 'oneTouch':
    case 'twoTouch':
    case 'fourTouch': return <ToggleOnIcon fontSize="large" />;
    default: return <DevicesOtherIcon fontSize="large" />;
  }
}

export default function DeviceTile({ device, onClick, subtitle }) {
  const name = device.DeviceName || device.ActualDeviceName || device.UniqueNumber;
  return (
    <Card sx={{ bgcolor: 'primary.main', borderRadius: 3 }}>
      <CardActionArea onClick={onClick} sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5, color: 'primary.contrastText' }}>
          {subtitle && (
            <Typography variant="caption" noWrap sx={{ opacity: 0.75, maxWidth: '100%' }}>
              {subtitle}
            </Typography>
          )}
          {iconFor(device.DeviceID)}
          <Typography variant="body1" fontWeight={600} noWrap sx={{ maxWidth: '100%' }}>
            {name}
          </Typography>
          <Typography variant="caption" sx={{ opacity: 0.8 }}>
            {deviceLabel(device.DeviceID)}
          </Typography>
          <DeviceStatusDot device={device} />
        </Box>
      </CardActionArea>
    </Card>
  );
}
